/**
 * [TLG]: #111927 - % de descuento de la ficha de producto por variante.
 *
 * snippets/custom-badges.liquid pinta el % de la variante seleccionada y deja en un JSON el % de
 * cada variante (null si no tiene descuento). Este custom element lo actualiza al cambiar de medida.
 *
 * El tema emite un change nativo sobre [name="id"] al pulsar un swatch (el mismo mecanismo que usa
 * tlg-product-total-price.js). La burbuja vive en la galeria, fuera del formulario, asi que
 * escuchamos en document y filtramos por las variantes de este producto.
 */
(function () {
  'use strict';

  var TAG_NAME = 'tlg-discount-badge';

  if (customElements.get(TAG_NAME)) return;

  class TlgDiscountBadge extends HTMLElement {
    connectedCallback() {
      this.discounts = this.readDiscounts();
      this.output = this.querySelector('[data-tlg-discount-output]');

      if (!this.discounts || !this.output) return;

      this.handleChange = this.handleChange.bind(this);
      document.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      if (this.handleChange) document.removeEventListener('change', this.handleChange);
    }

    readDiscounts() {
      var source = this.querySelector('[data-tlg-variant-discounts]');

      if (!source) return null;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return null;
      }
    }

    handleChange(event) {
      var target = event.target;

      if (!target || target.name !== 'id') return;
      if (!Object.prototype.hasOwnProperty.call(this.discounts, target.value)) return;

      this.render(this.discounts[target.value]);
    }

    render(discount) {
      if (discount) {
        this.output.textContent = discount;
        this.output.style.display = '';
      } else {
        this.output.style.display = 'none';
      }
    }
  }

  customElements.define(TAG_NAME, TlgDiscountBadge);
})();
